import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import compose from '../../hoc/compose';
import TextInput from '../textInput/textInput';
var inputConfiguration = {
  validateInitialValue: false,
  // This will prevent the initial "onChange" to be called
  syncDelay: 0,
  // This make sure validation are done synchroniously
  blurOnEnterKey: true,
  blurOnEscKey: true,
  focus: true,
  // TODO - remove from comoponent and change to prop
  initialSelectionStart: 0 // TODO - remove from comoponent and change to prop, this is business logic, you can expose via props
};
var EditableListItem = /*#__PURE__*/function (_React$Component) {
  function EditableListItem(props) {
    var _this;
    _classCallCheck(this, EditableListItem);
    _this = _callSuper(this, EditableListItem, [props]);
    _this.state = {
      newValueCandidate: props.initialValue,
      value: props.initialValue,
      isCandidateValid: true
    };
    _this.onBlur = function (e, isCanceled) {
      var _this$props = _this.props,
        onCancel = _this$props.onCancel,
        onConfirm = _this$props.onConfirm;
      var _this$state = _this.state,
        isCandidateValid = _this$state.isCandidateValid,
        newValueCandidate = _this$state.newValueCandidate,
        value = _this$state.value;
      if (isCanceled || !isCandidateValid) {
        // restore the previous valid value
        _this.setState({
          newValueCandidate: value,
          isCandidateValid: true
        }, function () {
          return onCancel();
        });
      } else {
        // accept the new value
        _this.setState({
          value: newValueCandidate
        }, function () {
          return onConfirm(newValueCandidate);
        });
      }
    };
    _this.onInputChange = function (newValueCandidate) {
      _this.setState({
        newValueCandidate: newValueCandidate,
        isCandidateValid: _this.props.validator(newValueCandidate)
      });
    };
    return _this;
  }
  _inherits(EditableListItem, _React$Component);
  return _createClass(EditableListItem, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        getClassName = _this$props2.getClassName,
        dataHook = _this$props2.dataHook,
        depth = _this$props2.depth,
        getInvalidMessage = _this$props2.getInvalidMessage,
        size = _this$props2.size,
        focus = _this$props2.focus,
        initialSelectionStart = _this$props2.initialSelectionStart,
        initialSelectionEnd = _this$props2.initialSelectionEnd;
      var _this$state2 = this.state,
        newValueCandidate = _this$state2.newValueCandidate,
        isCandidateValid = _this$state2.isCandidateValid;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: getClassName(classNames('tree-list-rename-item', {
          size: size
        }))
      }, /*#__PURE__*/React.createElement("div", {
        className: "depth-margin",
        style: {
          '--baseui-tree-list-rename-item-depth': depth
        }
      }), /*#__PURE__*/React.createElement(TextInput, _extends({
        className: "tree-list-rename-input",
        dataHook: "text-input"
      }, inputConfiguration, {
        focus: focus,
        initialSelectionStart: initialSelectionStart,
        initialSelectionEnd: initialSelectionEnd,
        isValid: this.state.isCandidateValid,
        invalidMessage: isCandidateValid ? '' : getInvalidMessage(newValueCandidate),
        onBlur: this.onBlur.bind(this),
        onChange: this.onInputChange.bind(this),
        value: newValueCandidate
      })));
    }
  }]);
}(React.Component);
EditableListItem.displayName = 'EditableListItem';
EditableListItem.propTypes = {
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Level of indentation (left margin) */
  depth: PropTypes.number,
  /** Receives the new value after change and returns an error message to display. Invoked with this parameter: <ol><li><code>newValueCandidate</code> - the new value (string)</li></ol> */
  getInvalidMessage: PropTypes.func.isRequired,
  /** The value on component mount */
  initialValue: PropTypes.string.isRequired,
  /** Invoked when a new value is accepted with this parameter: <ol><li><code>newValueCandidate</code> - the new value (string)</li></ol> */
  onConfirm: PropTypes.func.isRequired,
  /** Invoked when a new value is rejected with no parameters. */
  onCancel: PropTypes.func.isRequired,
  /**
   * @deprecated
   */
  size: PropTypes.oneOf(['small', 'medium']),
  /** Receives the new value after change and returns `true` if value is valid, or `false` otherwise.  Invoked with this parameter: <ol><li><code>newValueCandidate</code> - the new value (string)</li></ol> */
  validator: PropTypes.func.isRequired,
  /* Set to `true` to focus input field on component mount. */
  focus: PropTypes.bool,
  /* TextInput props - initialSelectionStart */
  initialSelectionStart: PropTypes.number,
  /* TextInput props - initialSelectionEnd */
  initialSelectionEnd: PropTypes.number
};
EditableListItem.defaultProps = {
  depth: 0,
  size: 'medium'
};
export default compose(EditableListItem);